module.exports = __webpack_public_path__ + "img/img_left_nav_sale_hover.7b28b7f6.svg";